function restoreState(cartContainer) {
    var maxCount = window.phe.customer.deviceType === "desktop" ? 4 : 2;
    var storageResult = window.phe.safeSessionStorage.tryGetItem("compareProductsIds", { reportFailure: false });
    if (storageResult.success) {
        var json = storageResult.value;
        if (json && json.length > 0) {
            cartContainer = cartContainer.concat(JSON.parse(json).slice(0, maxCount));
            processCartContainer(cartContainer, true);
        }
    }
    else {
        var cookie = window._.getCookie("compareProductIds");
        if (cookie && cookie.length > 0) {
            window._.ajax("/product/getCompareSummaries", "POST", null, function (data) {
                data.slice(0, maxCount).forEach(
                    function (item) {
                        cartContainer.push({
                            productImage: item.productImageUrl,
                            productId: item.productId
                        });
                    }
                );
                processCartContainer(cartContainer, true);
            });

        }
    }
}

function addToContainer(cartContainer, el) {
    cartContainer.push({
        productImage: el.querySelector("picture").outerHTML,
        productId: parseInt(el.getAttribute("data-productid"))
    });
}

function removeFromContainer(cartContainer, el) {
    var index = cartContainer.findIndex(
        (i) => i.productId === parseInt(el.getAttribute("data-productid"))
    );
    if (index > -1)
        return cartContainer.splice(index, 1);

    return false;
}

function persistState(cartContainer) {
    var persisted = window.phe.safeSessionStorage.setItem("compareProductsIds", JSON.stringify(cartContainer), { reportFailure: false });
    if (!persisted)
        window._.setCookie(
            "compareProductIds",
            cartContainer.map((el) => el.productId).join()
        );
}

function processCartContainer(cartContainer, setCheckboxes) {

    var template = document.querySelector('.template.cart-container-item-template').innerHTML;
    document.querySelector('#cart-container .slides').style.display = "none";
    document.querySelectorAll('#cart-container .item.product').forEach(function (el) {
        el.parentNode.removeChild(el);
    });

    cartContainer.map(function (item) {
        var newItem = template;
        newItem = newItem.replace('{{productImage}}', item.productImage);
        newItem = newItem.replace(/{{productId}}/g, item.productId);
        document.querySelector('#cart-container .slides').insertAdjacentHTML('beforeend', newItem);

    });

    document.querySelector('#cart-container .slides').style.display = "block";
    setCheckboxes && document.querySelectorAll('.product-checkbox input[type="checkbox"]').forEach(
        function (e) { e.checked = false }
    );

    if (cartContainer.length > 0) {
        window._.removeClassBySelector('#cart-container', 'hide');
        setCheckboxes && cartContainer.map(function (item) {
            var checkbox = document.querySelector('.product-checkbox input[type="checkbox"][data-productid="' + item.productId + '"]');
            if (checkbox)
                checkbox.checked = true;
        });
    }
    else {
        window._.addClassBySelector('#cart-container', 'hide');
    }

    document.querySelector("#compare-button").disabled = (cartContainer.length <= 1);
    document.querySelector("#compare-button").style.opacity = (cartContainer.length <= 1 ? "0.5" : "1");
    document.querySelector("#ami-button").style.display = cartContainer.length > 1 ? "none" : "none";
    document.querySelector("#return-to-top").style.display = cartContainer.length > 0 ? "none" : "block";
}
export function setupCompare() {
    if (!document.querySelector('.template.cart-container-item-template'))
        return;

    var cartContainer = [];

    restoreState(cartContainer);
    document.addEventListener("change", function (event) {
        var el = event.target.closest(".product-checkbox input[type='checkbox']");
        if (el) {
            var parent = document.querySelector('a.product-page-link[data-productid="' + el.getAttribute("data-productid") + '"]');
            if (el.checked) {
                if (cartContainer.length >= (phe.customer.deviceType === "desktop" ? 4 : 2)) {
                    el.checked = false;
                    return;
                }
                else {
                    window._.trackEvent("Select Product to Compare", 1, "Product Compare");
                    addToContainer(cartContainer, parent);
                }
            }
            else {
                removeFromContainer(cartContainer, parent);
            }
            persistState(cartContainer);
            processCartContainer(cartContainer);
        }
    });

    ["click", "keypress"].forEach(function (event) {
        document.querySelector("#cart-container").addEventListener(event, function (e) {
            var el = e.target.closest(".badge1.right");
            if (el) {
                if (e.type == 'click' || e.keyCode == 13) {
                    var checkbox = document.querySelector('.product-checkbox input[type="checkbox"][data-productid="' + el.getAttribute("data-productid") + '"]');
                    if (checkbox)
                        checkbox.dispatchEvent(new MouseEvent("click"));
                    else {
                        if (removeFromContainer(el)) {
                            persistState(cartContainer);
                            processCartContainer(cartContainer);
                        }
                    }
                }
            }
            e.preventDefault();
            e.stopPropagation();
            return false;
        });
    });

    document.addEventListener('products:loadmore', function () {
        if (window.phe.config.isSiteRedesign2022) {
            return;
        }

        cartContainer.map(function (item) {
            var checkbox = document.querySelector('.product-checkbox input[type="checkbox"][data-productid="' + item.productId + '"]');
            if (checkbox)
                checkbox.checked = true;
        });

    });

    document.querySelector("a.remove-all").addEventListener(
        "click", function () {
            cartContainer = [];
            persistStatecartContainer();
            processCartContainer(cartContainer, true);
        }
    );

    document.getElementById("compare-button").addEventListener(
        "click", function () {
            window._.trackEvent("Select Product to Compare", 2, "Product Compare");
            window.navigateToLocation("/product/compare?products=" + cartContainer.map((i) => i.productId).join());
            return false;
        }
    );
}
